/**
 * W1-11a (app-registry-keymap): `registry: Registry` (contract app/registry/types.ts, ARCHITECTURE.md §6.1).
 *
 * The app-wide registry over every discovered FeatureModule (shell first, then `src/features/**\/*.module.ts(x)` by
 * path; see loadModules.ts). Modules are loaded on first use; duplicate ids fail loudly in dev and tests.
 * Startup (W1-16 / main.tsx): `registry.attach({ services, when: () => router.whenContext() })` binds the services,
 * registers module when-atoms and runs module `init`s. Implementation and helpers: registryCore.ts.
 */

import { loadModules } from './loadModules';
import { createRegistry, type AppRegistry } from './registryCore';

export {
  createRegistry,
  type AppRegistry,
  type RegistryAttachment,
  type RegistryIssue,
  type TriggerEvent,
} from './registryCore';

export const registry: AppRegistry = createRegistry({ modules: loadModules });
